/** @jsx jsx */

import React, { Fragment as _, memo, useMemo } from 'react';
import { css, jsx } from '@emotion/core';
import EditableText from 'components/lib/EditableText';
import ContentCards from './ContentCards';
import ContentCard from './ContentCard';
import renderBlock from 'services/apiHelpers/renderBlock';
import { Row, Column, Button, Box } from '@chameleoncreator/creator-ui';
import Image from 'components/lib/Image';
import Video from 'components/lib/Video';
import Audio from 'components/lib/Audio';
import SVG from 'components/lib/SVG';
import Embed from 'components/lib/Embed';
import Media from 'components/lib/Media';
import { interactionContext } from './interactionContext';
import Container from 'components/Layouts/ContainerLogical';
import getBlockById from 'services/apiHelpers/getBlockById';
import continueBtn from '../ContinueBtn/continueBtn_v2';
import { Block } from '@chameleoncreator/creator-app';
import IELayout from 'components/Layouts/IELayout';
import EditableBtn from 'components/lib/EditableBtn';

const SingleColumnLayout = Row.bind({}) as any;
SingleColumnLayout.defaultProps = {
  ...(Row as any).defaultProps,
  flexDirection: 'column',
};

const TwoColumnLayout = Row.bind({}) as any;
TwoColumnLayout.defaultProps = {
  ...(Row as any).defaultProps,
  flexDirection: 'row',
};

const Components = {
  Row,
  Column,
  // Text: EditableText,
  // Text: ({ children, ...props }) => (
  //   <EditableText {...{ ...props, className: 'click-and-reveal-text' }} />
  // ),
  Text: EditableText,
  ContentCards,
  ContentCard,
  ColumnRowA: ({ children, ...props }) => children,
  ColumnRowB: ({ children, ...props }) => children,
  // Image: ({ children, ...props }) => {
  //   const mediaParent = getMediaParent(props.id);

  //   return mediaParent ? (
  //     <Image
  //       {...{
  //         ...props,
  //         // padding: 5,
  //         editWrapperType: props.hasOwnProperty('editWrapperType')
  //           ? props.editWrapperType
  //           : 1,
  //         editWrapperSize: '65%',
  //         editWrapperUseIcon: false,
  //       }}
  //     />
  //   ) : (
  //     <Image {...{ ...props, usePlaceholderValue: true }} />
  //   );
  // },
  Image: ({ children, ...props }) => {
    return (
      <Image
        {...{
          ...props,
          editWrapperType: 3,
          editWrapperPadding: 25,
        }}
      />
    );
  },
  Video,
  Audio,
  Transcript: () => null,
  // SVG: ({ children, ...props }) => (
  //   <SVG {...{ ...props, editWrapperType: 1 }} />
  // ),

  SVG,
  Embed,
  Media,
  TwoColumnLayout: TwoColumnLayout,
  SingleColumnLayout: SingleColumnLayout,
  ContinueButton: continueBtn,
  EditableButton: EditableBtn,
  ...IELayout(interactionContext),
};

// const ContentCardDisplay = memo((props: any) => {
const ContentCardDisplay = (props: any) => {
  const interactionBlock = getBlockById(props.blockId);
  return (
    <Container
      id={interactionBlock.id}
      key={interactionBlock.id}
      {...interactionBlock.props}
      {...props}
    >
      <interactionContext.Provider value={{ ...interactionBlock }}>
        {(interactionBlock.children as Block[]).map(child => {
          return renderBlock(child, Components);
        })}
      </interactionContext.Provider>
    </Container>
  );
};
// }, shouldUpdate);

export default ContentCardDisplay;
